import styled from 'styled-components';
import { Heading1 } from 'packages/smart-home-support/components/Typography';

export default styled(Heading1)`
  color: white;
  margin-bottom: 5px;
  max-width: 100%;
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/HeroTitle.tsx